export default __webpack_public_path__ + "static/media/maure_de_bretagne2.477203ed.jpg";